import { RugbyFoulSanctions } from '../models/rugby-foul-type';
import { Locales } from './locales';

export const RugbyFoulSanctionLocalization = {
  [Locales.ru]: {
    [RugbyFoulSanctions.scrum]: 'Схватка',
    [RugbyFoulSanctions.lineout]: 'Коридор',
    [RugbyFoulSanctions.start_kick]: 'Начальный удар',
    [RugbyFoulSanctions.free_kick]: 'Свободный удар',
    [RugbyFoulSanctions.penalty_shot]: 'Штрафной удар',
    [RugbyFoulSanctions.twenty_two_meters_kick]: 'Удар с 22 метров',
    [RugbyFoulSanctions.conversion_cancel]: 'Отмена удара',
    [RugbyFoulSanctions.yellow_card]: 'Желтая карточка',
    [RugbyFoulSanctions.red_card]: 'Красная карточка',
  },
  [Locales.en]: {
    [RugbyFoulSanctions.scrum]: 'Scrum',
    [RugbyFoulSanctions.lineout]: 'Lineout',
    [RugbyFoulSanctions.start_kick]: 'Start kick',
    [RugbyFoulSanctions.free_kick]: 'Free kick',
    [RugbyFoulSanctions.penalty_shot]: 'Penalty kick',
    [RugbyFoulSanctions.twenty_two_meters_kick]: 'Kick from 22 meters',
    [RugbyFoulSanctions.conversion_cancel]: 'Conversion cancel',
    [RugbyFoulSanctions.yellow_card]: 'Yellow card',
    [RugbyFoulSanctions.red_card]: 'Red card',
  }
};
